interface props {
    height: string | number;
    width: string | number;
    viewBox?: string;
}

export default function CarMaxLogoInternal({
    height = '40',
    width = '45',
    viewBox = '0 0 40 40',
}: props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            fill="none"
            aria-label="CarMax Auctions Internal Logo"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.96077 18.5708C8.88813 19.9449 8.43668 20.3427 7.76713 20.3427C6.46563 20.3427 6.35698 18.8611 6.35698 16.8711C6.35698 14.7739 6.48364 13.3994 7.82195 13.3994C8.4543 13.3994 8.99679 13.6894 9.06903 15.172H13.8066C13.7885 11.3391 11.0041 10 7.7133 10C3.30075 10 0.878246 12.7485 1.00471 16.817C1.00471 20.9583 3.11985 23.7421 7.69509 23.7421C10.9318 23.7421 13.8066 22.1697 13.8066 18.5708H8.96077ZM15.4058 23.2825H20.5049V15.4262C20.5049 14.4222 20.9471 14.021 21.431 14.021C21.9155 14.021 22.3155 14.4976 22.3155 15.3763V23.2825H27.4146V15.4262C27.4146 14.4222 27.8564 14.021 28.3415 14.021C28.8264 14.021 29.2256 14.4976 29.2256 15.3763V23.2825H34.3251V14.9C34.3251 11.5605 32.7869 10.3063 30.6593 10.3063C29.4575 10.3063 28.193 10.7831 27.3291 12.5907C26.6766 11.034 25.4972 10.3063 23.8753 10.3063C22.6747 10.3063 21.4098 10.7831 20.5463 12.5907H20.5049L20.3781 10.6833H15.4058V23.2825ZM15.5377 30.2368H25.7413V27.1543H15.5377V30.2368ZM28.6321 30.2368H38.8353V27.1543H28.6321V30.2368Z"
                fill="#053361"
            />
        </svg>
    );
}
